"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaxDetailsToJSON = exports.TaxDetailsFromJSONTyped = exports.TaxDetailsFromJSON = exports.instanceOfTaxDetails = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the TaxDetails interface.
 */
function instanceOfTaxDetails(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfTaxDetails = instanceOfTaxDetails;
function TaxDetailsFromJSON(json) {
    return TaxDetailsFromJSONTyped(json, false);
}
exports.TaxDetailsFromJSON = TaxDetailsFromJSON;
function TaxDetailsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'taxPctMicro': !(0, runtime_1.exists)(json, 'tax_pct_micro') ? undefined : json['tax_pct_micro'],
        'taxMicroAmount': !(0, runtime_1.exists)(json, 'tax_micro_amount') ? undefined : json['tax_micro_amount'],
    };
}
exports.TaxDetailsFromJSONTyped = TaxDetailsFromJSONTyped;
function TaxDetailsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'tax_pct_micro': value.taxPctMicro,
        'tax_micro_amount': value.taxMicroAmount,
    };
}
exports.TaxDetailsToJSON = TaxDetailsToJSON;
